import { useEffect, useState, useTransition } from 'react';

import { loadJournalList } from '~modules/journal/api';
import { JournalDto } from '~modules/journal/model';

export function useJournalList(
	date_start?: Date | null,
	date_end?: Date | null,
	user_id?: number,
	limit?: number,
	offset?: number,
) {
	const [list, setList] = useState<JournalDto[]>([]);
	const [total, setTotal] = useState(0);
	const [pending, startLoading] = useTransition();

	useEffect(() => {
		if (limit === undefined) return;
		let cancelled = false;
		startLoading(async () => {
			try {
				const data = await loadJournalList(date_start, date_end, user_id, limit, offset);
				if (cancelled) return;
				setList(data.list);
				setTotal(data.total);
			} catch (error) {
				if (cancelled) return;
				console.error('Failed to load journal list', error);
				setList([]);
				setTotal(0);
			}
		});
		return () => {
			cancelled = true;
		};
	}, [date_start, date_end, user_id, limit, offset]);

	return { pending, list, total };
}
